<script>
import EventBus from './EventBus.vue'
import SideForm from './components/blocks/SideForm.vue'
import CartSideForm from './components/blocks/CartSideForm.vue'
import CartHeaderDropdown from './components/blocks/CartHeaderDropdown.vue'
import MultiSelect from './components/blocks/MultiSelect.vue'
import VantivesMultiplier from './components/blocks/VantivesMultiplier.vue'
import SupplierEmailsMultiplier from './components/blocks/SupplierEmailsMultiplier.vue'
import ConfirmModal from './components/blocks/ConfirmModal.vue'
import CheckoutSyncContainer from './components/blocks/CheckoutSyncContainer.vue'
import FileInput from './components/blocks/FileInput.vue'
import ImageOverlay from './components/blocks/ImageOverlay.vue'
import ActionBuilderOrderSummary from './components/blocks/ActionBuilderOrderSummary.vue'
import ActionBuilderVisibilityItems from './components/blocks/ActionBuilderVisibilityItems.vue'
import PosMultiSelect from './components/blocks/PosMultiSelect.vue'
import ActionBuilderPrizeSelector from './components/blocks/ActionBuilderPrizeSelector.vue'


export default {
    components: {
        SideForm,
        CartSideForm,
        CartHeaderDropdown,
        MultiSelect,
        VantivesMultiplier,
        SupplierEmailsMultiplier,
        ConfirmModal,
        CheckoutSyncContainer,
        FileInput,
        ImageOverlay,
        ActionBuilderOrderSummary,
        ActionBuilderVisibilityItems,
        PosMultiSelect,
        ActionBuilderPrizeSelector,
    },

    el: '#wrapper',

    data() {
        return {
            cartItems: vueapp_cartItems, // vueapp_ is from global scope (see master.blade.php)
            cartTotalValue: vueapp_cartTotalValue, // vueapp_ is from global scope (see master.blade.php)
            cartTotalValueFormatted: vueapp_cartTotalValueFormatted, // vueapp_ is from global scope (see master.blade.php)
        }
    },

    created() {
        // events are emitted on $root, so listen here
        this.$on('cartsideform.create', (productId) => {
            this.$refs.cartsideform.openCreate(productId)
        })
        this.$on('cartsideform.edit', (id) => {
            this.$refs.cartsideform.openEdit(id)
        })

        this.$on('imageOverlay.open', (src) => {
            this.$refs.imageOverlay.open(src)
        })

        EventBus.$on('cart-update', (data) => {
            this.cartItems = data.cartItems
            this.cartTotalValue = data.cartTotalValue
            this.cartTotalValueFormatted = data.cartTotalValueFormatted
        })
    },
}
</script>
